import { render, staticRenderFns } from "./ModalAddress.vue?vue&type=template&id=282d18a4&scoped=true"
import script from "./ModalAddress.vue?vue&type=script&lang=ts"
export * from "./ModalAddress.vue?vue&type=script&lang=ts"
import style0 from "./ModalAddress.vue?vue&type=style&index=0&id=282d18a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282d18a4",
  null
  
)

export default component.exports